import { PauseCircle } from "lucide-react";
import { Button } from "../components/ui/button";
import { api } from "../lib/api";

/** Landing screen a paused tenant's users get redirected to — see
 * lib/api.js's response interceptor, which catches the 403 TENANT_PAUSED
 * detail routes_auth.get_current_user sends from any authenticated
 * endpoint while a platform admin has the institution on seasonal
 * Off-Season Hold (routes_platform.set_tenant_pause). Deliberately not
 * gated by Protected/AuthContext — a paused user's own /auth/me call is
 * itself blocked by the same gate, so this page has to stand on its own,
 * same as TenantSuspended.jsx. Distinct copy/route from that page on
 * purpose: a pause is a deliberate hold, not an overdue/suspended
 * account, and shouldn't read like one. */
export default function TenantPaused() {
  const logout = () => {
    api.post("/auth/logout").catch(() => {}).finally(() => { window.location.href = "/login"; });
  };

  return (
    <div className="min-h-screen bg-slate-100 flex flex-col items-center justify-center px-4 py-10" data-testid="tenant-paused-page">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-xl shadow-slate-200/70 border border-slate-200 p-8 text-center">
        <div className="mx-auto h-14 w-14 rounded-full bg-blue-100 flex items-center justify-center">
          <PauseCircle className="w-7 h-7 text-blue-600" />
        </div>
        <h1 className="font-display text-xl font-bold text-slate-900 mt-4">Off-Season Hold</h1>
        <p className="text-sm text-slate-500 mt-3 leading-relaxed">
          Institution workspace is in Off-Season Hold. Contact Platform Admin to resume.
        </p>
        <Button variant="outline" className="mt-6" onClick={logout} data-testid="tenant-paused-logout">
          Sign out
        </Button>
      </div>
      <p className="text-center text-xs text-slate-400 mt-6">Powered by EduPulse Admissions</p>
    </div>
  );
}
